/**
 *
 * Ask
 *
 */

import { mapGetters, mapActions } from 'vuex';

export const QaSendSmsNotificationMixin = {
  name: 'QaSendSmsNotificationMixin',

  data: () => {
    return {
      sendSmsNotification: false,
    };
  },

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),
  },

  methods: {
    ...mapActions({
      updateProfile: 'updateProfile',
    }),

    setSendSmsNotification() {
      this.updateProfile({
        sendSmsNotification: this.sendSmsNotification,
      });
    },
  },

  created() {
    this.sendSmsNotification = this.mg_userInfo.profile.sendSmsNotification;
  },
};
